'use client';

import {rustoreOpenTestIds} from '@shared/Modals/RustoreOpen/testid';
import classNames from '@sindresorhus/class-names';
import {retryPromise} from '@utils/retryPromise';
import dynamic from 'next/dynamic';
import {useCallback, useState} from 'react';

import {useKeypress} from '@utils/hooks/useKeypress';

import styles from './RustoreOpen.module.scss';

const RuStoreOpenModal = dynamic(
  retryPromise(
    async () =>
      import(
        /* webpackChunkName: "RuStoreOpenModal" */ '@shared/Modals/RustoreOpen/parts/RuStoreOpenModal/RuStoreOpenModal'
      ),
  ),
  {ssr: false},
);

type Props = {
  logTmrEvent: (eventName: string, params: Record<string, unknown>) => void;
};

export const RustoreOpen = ({logTmrEvent}: Props) => {
  const [modalShown, setModalShown] = useState(false);

  const setShowModal = useCallback(() => {
    logTmrEvent('button.click', {button_text: 'Предложить приложение'});
    setModalShown((current) => !current);
  }, []);

  useKeypress('Escape', setShowModal, modalShown);

  return (
    <>
      {modalShown && <RuStoreOpenModal setShowModal={setShowModal} />}
      <button
        className={classNames(styles.link)}
        rel="noopener noreferrer"
        onClick={setShowModal}
        data-testid={rustoreOpenTestIds.rustoreOpenShowModalButton}
      >
        Предложить приложение
      </button>
    </>
  );
};
